import React, { useEffect } from "react";
import ManagerDashboardWapper from "../../../../layout/wrapper/ManagerDashboardWapper";
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Popover,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  tooltipClasses,
} from "@mui/material";
import styles from "../../../../styles/pages/user/managerdashboard/manager-dashboard-messages.module.scss";
import NoMessageIcon from "../../../../ui/Icons/NoMessageIcon";
import { styled } from "@mui/material/styles";
import IconView from "../../../../public/assets/images/icon-view.svg";
import { Link } from "react-router-dom";
import CalenderIcon from "../../../../ui/Icons/CalenderIcon";
import PrevIcon from "../../../../ui/Icons/PrevIcon";
import NextIcon from "../../../../ui/Icons/NextIcon";
import useFetch from "../../../../hooks/api/useFetch";
import {
  getMonthQueryRange,
  getMonthRange,
  getPagination,
  getUtcDate,
  getUtcTime,
  getYearRange,
} from "../../../../lib/functions/utils.lib";

const VsidTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFF",
    minWidth: 126,
    borderRadius: "5px",
    padding: "6.5px 0",
    width: "100%",
    boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",

    "& .MuiTypography-root": {
      fontWeight: "500",
      fontSize: "12px",
      color: "#000",
      textAlign: "center",
    },
  },
}));

const ViewTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFF",
    minWidth: 112,
    borderRadius: "5px",
    padding: "6.5px 0",
    width: "100%",
    boxShadow: "0px 0px 6px 0px rgba(0, 0, 0, 0.25)",

    "& .MuiTypography-root": {
      fontWeight: "500",
      fontSize: "12px",
      color: "#000",
      textAlign: "center",
    },
  },
}));

export default function MyMessage() {
  const [month, setMonth] = React.useState("");
  const [year, setYear] = React.useState("");
  const [archive, setArchive] = React.useState(false);
  const [status, setStatus] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);

  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };

  const handleChange2 = (event) => {
    setMonth(event.target.value);
  };

  const handleChange3 = (event) => {
    setYear(event.target.value);
  };

  const reslovedClick = () => {
    setArchive((prev) => !prev);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const {
    data: messages,
    isLoading,
    isSuccess,
    isError,
  } = useFetch(
    ["messages", status, archive, month, year],
    `inquiries?type=message${
      status.toString()
        ? `&${status == 2 ? "need_your_reply=yes" : "status=" + status}`
        : ""
    }
        &archive=${archive ? 1 : 0}
        ${
          month && year
            ? `&from=${getMonthQueryRange(month, year, "obj").from_date}&to=${
                getMonthQueryRange(month, year, "obj").to_date
              }`
            : ""
        }&page=${currentPage}`
  );

  const [paginationData, setPaginationData] = React.useState({
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handleNextPage = () => {
    if (paginationData.hasNextPage) setCurrentPage((prev) => prev + 1);
  };
  const handlePrevPage = () => {
    if (paginationData.hasPrevPage) setCurrentPage((prev) => prev - 1);
  };

  const getStatus = (inquiry) => {
    if (!inquiry?.status) {
      if (inquiry?.initiated?.name === inquiry?.last_message?.sender?.name)
        return {
          name: "Need your reply",
          class: `${styles.noNeed} ${styles.statusTxt}`,
        };
      return {
        name: "Pending",
        class: `${styles.pending} ${styles.statusTxt}`,
      };
    }
    return {
      name: "Resolved",
      class: `${styles.removed} ${styles.statusTxt}`,
    };
  };

  useEffect(() => {
    const { hasNextPage, hasPrevPage } = getPagination(
      messages?.data?.meta?.currentPage,
      messages?.data?.meta?.lastPage
    );
    setPaginationData({ hasNextPage: hasNextPage, hasPrevPage: hasPrevPage });
  }, [messages]);
  return (
    <ManagerDashboardWapper>
      {/* ====================================== */}
      {/* =========== NO ITEMS START =========== */}
      {/* ====================================== */}

      {/* <Box className={styles.emptyMsg}>
                <NoMessageIcon />
                <Typography variant="body1">
                    You don't have any team messages at the moment.
                </Typography>
            </Box> */}

      {/* ====================================== */}
      {/* ============ NO ITEMS END ============ */}
      {/* ====================================== */}
      <Paper elevation={0} className={styles.pageManager}>
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          className={styles.messageHeader}
        >
          <Select
            value={status}
            onChange={handleChange1}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            MenuProps={{
              PaperProps: {
                sx: {
                  boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                  borderRadius: "7px",
                  marginTop: "5px",

                  "& .MuiMenuItem-root": {
                    padding: 0,
                    fontSize: "11px",
                    fontWeight: "500",
                    color: "#525050",
                    lineHeight: "1",
                    "&:hover": {
                      backgroundColor: "#ffffff",
                      color: "#111ae9",
                    },
                    "&:not(:last-child)": {
                      marginBottom: "10px",
                    },
                    "&:first-child": {
                      display: "none",
                    },
                  },
                  "& .Mui-selected": {
                    background: "#fff !important",
                  },

                  "& .MuiList-root": {
                    padding: "20px 14px",
                    minWidth: "134px",
                  },
                },
              },
            }}
          >
            <MenuItem value="">Message Status</MenuItem>
            <MenuItem value="2">Need your reply</MenuItem>
            <MenuItem value="0">Pending</MenuItem>
            <MenuItem value="1">Resolved</MenuItem>
          </Select>

          <Box className={styles.creationDate}>
            <Button
              aria-describedby={id}
              variant="contained"
              onClick={handleClick}
              endIcon={<CalenderIcon />}
            >
              Creation Date
            </Button>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                  borderRadius: "7px",
                  marginTop: "5px",
                  padding: "24px",
                  maxWidth: "254px",
                  width: "100%",
                  "& .MuiTypography-caption": {
                    fontWeight: "500",
                    fontSize: "13px",
                    color: "#494949",
                    marginBottom: "8px",
                    display: "block",
                  },
                },
              }}
            >
              <Typography variant="caption">Created in</Typography>
              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                className={styles.selectDate}
              >
                <Select
                  value={month}
                  onChange={handleChange2}
                  displayEmpty
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                        borderRadius: "7px",
                        marginTop: "5px",

                        "& .MuiMenuItem-root": {
                          padding: 0,
                          fontSize: "11px",
                          fontWeight: "500",
                          color: "#525050",
                          lineHeight: "1",
                          "&:hover": {
                            backgroundColor: "#ffffff",
                            color: "#111ae9",
                          },
                          "&:not(:last-child)": {
                            marginBottom: "10px",
                          },
                          "&:first-child": {
                            display: "none",
                          },
                        },
                        "& .Mui-selected": {
                          background: "#fff !important",
                        },

                        "& .MuiList-root": {
                          padding: "20px 14px",
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="">Month</MenuItem>
                  {getMonthRange().map((item, index) => (
                    <MenuItem value={item?.value} key={index}>
                      {item?.month}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  value={year}
                  onChange={handleChange3}
                  displayEmpty
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                        borderRadius: "7px",
                        marginTop: "5px",

                        "& .MuiMenuItem-root": {
                          padding: 0,
                          fontSize: "11px",
                          fontWeight: "500",
                          color: "#525050",
                          lineHeight: "1",
                          "&:hover": {
                            backgroundColor: "#ffffff",
                            color: "#111ae9",
                          },
                          "&:not(:last-child)": {
                            marginBottom: "10px",
                          },
                          "&:first-child": {
                            display: "none",
                          },
                        },
                        "& .Mui-selected": {
                          background: "#fff !important",
                        },

                        "& .MuiList-root": {
                          padding: "20px 14px",
                        },
                      },
                    },
                  }}
                >
                  <MenuItem value="">Year</MenuItem>
                  {getYearRange().map((item, index) => (
                    <MenuItem value={item.value} key={index}>
                      {item.year}
                    </MenuItem>
                  ))}
                </Select>
              </Stack>
            </Popover>
          </Box>
          
          <Button
            className={`${
              archive
                ? `${styles.btnArchive} ${styles.activeBtnArchive}`
                : `${styles.btnArchive}`
            }`}
            onClick={reslovedClick}
          >
            Archive
          </Button>
        </Stack>
        <Box className={styles.messageTable}>
          <TableContainer>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className={styles.thvsid}>VSID</TableCell>
                  <TableCell className={styles.thsender}>Sender</TableCell>
                  <TableCell className={styles.threcipient}>
                    Recipient
                  </TableCell>
                  <TableCell className={styles.thmessage}>Message</TableCell>
                  <TableCell className={styles.thcreation}>
                    Creation Date
                  </TableCell>
                  <TableCell className={styles.thstatus}>
                    {archive ? "Resolved On" : "Status"}
                  </TableCell>
                  <TableCell className={styles.thview} align="center">
                    View
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isSuccess &&
                  messages?.data?.data.map((item, index) => {
                    if (
                      status === 0 &&
                      item?.initiated?.name === item?.last_message?.sender?.name
                    )
                      return "";
                    else if (
                      status === 2 &&
                      item?.initiated?.name !== item?.last_message?.sender?.name
                    )
                      return "";
                    else if (status === 2 && item?.status) return "";
                    return (
                      <TableRow key={index}>
                        <TableCell className={styles.thvsid}>
                          <VsidTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Open video page
                                </Typography>
                              </React.Fragment>
                            }
                            placement="bottom-start"
                          >
                            <Link to="">{item?.id}</Link>
                          </VsidTooltip>
                        </TableCell>
                        <TableCell className={styles.thsender}>
                          <Typography variant="body1">
                            {item?.initiated?.name}
                          </Typography>
                          <Typography variant="caption">
                            {item?.initiated?.role?.display_name}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.threcipient}>
                          <Typography variant="body1">
                            {item?.recipent?.name}
                          </Typography>
                          <Typography variant="caption">
                            {item?.recipent?.role?.display_name}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thmessage}>
                          <Typography variant="body1">
                            {item?.message?.length > 20
                              ? item?.message?.slice(0, 110) + "..."
                              : item?.message}
                          </Typography>
                        </TableCell>
                        <TableCell className={styles.thcreation}>
                          <Typography variant="body1">
                            {getUtcDate(item?.created)} <br />{" "}
                            {getUtcTime(item?.created)}
                          </Typography>
                        </TableCell>
                        <TableCell className={getStatus(item)?.class}>
                          {archive ? (
                            <Typography
                              variant="body1"
                              className={styles.resolvedTxt}
                            >
                              {getUtcDate(item?.resolved_at)} <br />{" "}
                              {getUtcTime(item?.resolved_at)}
                            </Typography>
                          ) : (
                            <Typography variant="body2">
                              {getStatus(item)?.name}
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell className={styles.thview} align="center">
                          <ViewTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Open Message
                                </Typography>
                              </React.Fragment>
                            }
                            placement="bottom-end"
                          >
                            <Link
                              to={`/manager-dashboard/message-details/${item?.id}`}
                            >
                              <img
                                src={IconView}
                                width={16}
                                height={16}
                                alt="icon"
                              />
                            </Link>
                          </ViewTooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack
            direction="row"
            flexWrap="wrap"
            alignItems="center"
            className="btnPagination"
          >
            <Button
              startIcon={<PrevIcon />}
              disabled={!paginationData.hasPrevPage}
              onClick={handlePrevPage}
            >
              Prev
            </Button>
            <Button
              endIcon={<NextIcon />}
              disabled={!paginationData.hasNextPage}
              onClick={handleNextPage}
            >
              Next
            </Button>
          </Stack>
        </Box>
      </Paper>
    </ManagerDashboardWapper>
  );
}
